export default __webpack_public_path__ + "static/miastowminutach-f4db49b2495e3900b9d4971c42065c89.jpg";